import { createTheme } from "@material-ui/core/styles";

export const theme = createTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        color: "rgba(62, 61, 63, 1)",
        backgroundColor: "white",
        border: "1px solid #8B8C90",
        borderRadius: "10px",
        letterSpacing: "0.18px",
        fontFamily: "OpenSansRegular",
        fontSize: "20px",
        boxShadow:
          "0px 12px 17px rgba(62, 61, 63, 0.14), 0px 5px 22px rgba(62, 61, 63, 0.12), 0px 7px 8px rgba(62, 61, 63, 0.2)",
      },
    },
  },
});
